import { Link, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import PilotChecksPanel from '../../components/PilotChecksPanel/PilotChecksPanel';
import ProfileDocumentsFiles from '../../components/ProfileDocumentsFiles/ProfileDocumentsFiles';
import { parseProfileUserId, profileBasePath } from './profilePaths';
import './ProfilePage.css';

const ProfileDocumentsPage = () => {
  const { userId: userIdParam } = useParams();
  const { currentUserId, user, isAdmin, isTechnician } = useAuth();
  const dateFormat = user?.date_format === 'long' ? 'long' : 'dot';

  const paramId = parseProfileUserId(userIdParam);
  const targetUserId = paramId ?? currentUserId;
  const isOwn = targetUserId === currentUserId;
  const canEdit = isOwn || isAdmin;
  const basePath = profileBasePath(targetUserId, currentUserId);
  const accessDenied =
    (Boolean(userIdParam) && paramId == null) || (!isOwn && !isAdmin);

  if (accessDenied) {
    return <Navigate to="/profile" replace />;
  }

  if (isTechnician && isOwn) {
    return (
      <div className="profile-page">
        <p className="profile-role-hint">
          Документы пилота недоступны для роли «техник».
        </p>
        <div className="profile-back-wrap">
          <Link to="/profile" className="profile-back-link">
            ← Личный кабинет пилота
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <div className="profile-subpage-header">
        <Link to={basePath} className="profile-back-link">
          ← Личный кабинет пилота
        </Link>
        <h2>{isOwn ? 'Мои данные' : 'Данные пилота'}</h2>
        <p className="profile-subpage-hint">
          Даты проверок и файлы: свидетельство частного пилота, ВЛЭК, справка о
          проверке навыков и иные документы
        </p>
      </div>
      <PilotChecksPanel
        userId={targetUserId}
        dateFormat={dateFormat}
        canEdit={canEdit}
      />
      <ProfileDocumentsFiles
        userId={targetUserId}
        canEdit={canEdit}
        dateFormat={dateFormat}
      />
    </div>
  );
};

export default ProfileDocumentsPage;
